export default {
  baselink: "https://eig.ge/benefitsapi/api/v1/",
  //baselink: "http://192.168.2.212:40004/api/v1/",
  //baselink: "https://localhost:44340/api/v1/",

  getHeaders() {
    const user = JSON.parse(localStorage.getItem("User"));
    let token = "";
    if (user) {
      token = user.token;
    }

    let retVal = {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    };
    return retVal;
  },
};
